import { Link, useNavigate } from 'react-router-dom';
import { LogOut, LayoutDashboard, FileText, User, Building2, TrendingUp, File } from 'lucide-react';
import { ThemeToggle } from './ThemeToggle';
import { useAuthStore } from '../store/authStore';
import { useThemeStore } from '../store/themeStore';
import { useState, useEffect } from 'react';
import { unidadesApi } from '../api/backend';
import axisLogoLight from '../assets/axis-logo-light.png';
import axisLogoDark from '../assets/axis-logo-dark.png';
import { Notifications } from './Notifications';

const menuItems = [
  {
    link: '/dashboard',
    label: 'Dashboard',
    icon: (<LayoutDashboard className="w-4 h-4" />)
  },
  {
    link: '/prestacoes',
    label: 'Prestações',
    icon: (<FileText className="w-4 h-4" />)
  },
  {
    link: '/documentos',
    label: 'Documentos',
    icon: (<File className="w-4 h-4" />)
  },
  {
    link: '/relatorios',
    label: 'Relatórios',
    icon: (<TrendingUp className="w-4 h-4" />)
  },
  {
    link: '/unidades',
    label: 'Unidades',
    isAdmin: true,
    icon: (<Building2 className="w-4 h-4" />)
  }
]

export function Navbar() {
  const { user, logout, isAdmin, selectedUnidadeId, userType } = useAuthStore();
  const { theme } = useThemeStore();
  const navigate = useNavigate();
  const [unidadeNome, setUnidadeNome] = useState<string | null>(null);

  // Selecionar logo baseado no tema
  const currentLogo = theme === 'dark' ? axisLogoDark : axisLogoLight;

  useEffect(() => {
    const loadUnidadeNome = async () => {
      if (selectedUnidadeId) {
        try {
          const unidades = await unidadesApi.list();
          const unidade = unidades.find((u: any) => u.id === selectedUnidadeId);
          if (unidade) {
            setUnidadeNome(unidade.nome);
          }
        } catch (error) {
          console.error('Error loading unidade:', error);
        }
      }
    };

    loadUnidadeNome();
  }, [selectedUnidadeId]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const displayName = isAdmin() 
    ? (selectedUnidadeId ? unidadeNome || 'Carregando...' : 'Administrador')
    : (unidadeNome || user?.nome || user?.display_name || 'Cliente');

  return (
    <nav className="bg-white dark:bg-gray-900 shadow-sm border-b border-gray-200 dark:border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="flex items-center space-x-3">
              <img 
                src={currentLogo} 
                alt="AXIS Tecnologia" 
                className="h-12 w-auto object-contain"
              />
            </Link>

            <div className="hidden md:flex space-x-4">
              {
                menuItems.map((menu) => {
                  return (
                    <Link to={menu.link} className="flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors">
                      {menu.icon}
                      <span>{menu.label}</span>
                    </Link>
                  )
                })
              }
              {/*userType === 'admin' && (
                <Link
                  to="/unidades"
                  className="flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                >
                  <Building2 className="w-4 h-4" />
                  <span>Unidades</span>
                </Link>
              )*/}
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <ThemeToggle />
            <Notifications />
            
            {user && (
              <div className="flex items-center space-x-3">
                <Link
                  to="/perfil"
                  className="flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                >
                  {user.photo_url ? (
                    <img
                      src={user.photo_url}
                      alt={displayName}
                      className="w-8 h-8 rounded-full object-cover"
                    />
                  ) : (
                    <User className="w-5 h-5" />
                  )}
                  <span className="hidden sm:inline">{displayName}</span>
                </Link>
                <button
                  onClick={handleLogout}
                  className="p-2 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                  aria-label="Logout"
                >
                  <LogOut className="w-5 h-5" />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
